module.exports = __webpack_public_path__ + "static/media/step1img1.2af75486.jpg";